import { Send } from 'lucide-react'
import { PortalPjAreaHubCard } from '@/components/PortalPj/PortalPjAreaHubCard'
import type { PortalTypeKey } from '@/components/Financeiro/solicitacoes/financeSolicitacoesConfig'

type SolicitationItem = {
  key: PortalTypeKey
  title: string
  description: string
}

type Props = {
  items: SolicitationItem[]
  onSelect: (key: PortalTypeKey) => void
}

export function GestorSolicitacoesTab({ items, onSelect }: Props) {
  return (
    <div className='mx-auto max-w-3xl'>
      <div className='rounded-xl bg-bg-primary p-5 sm:p-6'>
        <div className='space-y-6'>
          <header>
            <h2 className='text-base font-semibold text-text-primary'>Como podemos ajudar você?</h2>
            <p className='mt-2 text-sm leading-relaxed text-text-muted'>
              Abra chamados para o financeiro e RH. Cada solicitação gera protocolo e aparece na aba
              Chamados.
            </p>
          </header>

          <div className='space-y-3'>
            <p className='flex items-center gap-2 text-sm font-medium text-text-primary'>
              <Send size={16} className='text-accent' aria-hidden />
              Entre em contato conosco a respeito de
            </p>

            <div className='space-y-3'>
              {items.map((item) => (
                <PortalPjAreaHubCard
                  key={item.key}
                  title={item.title}
                  summary={item.description}
                  onClick={() => onSelect(item.key)}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
